<script setup>
    
    import { search_ui_styles } from '@/utilities/ui';

    const { isLoading } = useLoadingIndicator()
    
    const { $bus } = useNuxtApp();

    const props = defineProps({
        options: Object,
    })

    const open = defineModel('open');
    const route = useRoute()
    const router = useRouter()
    
    const facets = {
        '': [],
        'sessions': ['type:Session'],
        'speakers': ['type:Speaker'],
        'posts': ['type:BlogPage'],
        'sponsors': ['type:Sponsor'],
    };

    const searchOptions = computed(() => ({
        requestOptions: {
            facetFilters: route.query.search ? facets[route.query.search || ''] : [],
        },
    }));

    const handleClose = () => {
        // Apparently we can fire too fast and miss the route query update from the middlware.
        setTimeout(() => {
            if (isLoading.value) return;
            const currentQuery = { ...route.query };
            delete currentQuery.modal;
            delete currentQuery.search;
            router.replace({ query: currentQuery });
        }, 1000);
    }

    const handleOpen = (val) => {
        if (val) { 
            $bus.emit('drawer-open');
        }
        else if (!val) {
            $bus.emit('drawer-close');
            handleClose();
        }
    }

    const closeSearch = () => {
        handleOpen(false);
    }

    const close_styles = {
        icon: 'i-lucide-x',
        color: 'black',
        variant: 'round',
        class: 'close-button',
    }

</script>
<template>
    <UModal v-model:open="open" fullscreen :dismissible="false" title="Search" :close="close_styles" description="Search INBOUND content" @update:open="handleOpen" :ui="search_ui_styles" class="search-modal">
        <template #body>
            <div class='modal-container'>
                <GlobalAlgolia @closeSearch="handleClose" :searchOptions="searchOptions" />
            </div>
        </template>
    </UModal>
</template>